import React from 'react'

// Css
import './styles/Build.css'

import { Box } from '../../common/Box'
import { px2Rem } from '../../../themes/Mixins'
import Icon from '../../common/Icon'

const Build = ({ isAnimate, scale }) => {
  const buildItems = [
    {
      icon: 'buildWindows',
      class: '',
      style: {
        width: `calc(${px2Rem(56)}*${scale})`,
        height: `calc(${px2Rem(51)}*${scale})`,
        right: '0',
        top: '0'
      }
    },
    {
      icon: 'buildCogBig',
      class: 'cog-big',
      style: {
        width: `calc(${px2Rem(32)}*${scale})`,
        height: `calc(${px2Rem(32)}*${scale})`,
        bottom: '0',
        left: '0'
      }
    },
    {
      icon: 'buildCogSmall',
      class: 'cog-small',
      style: {
        width: `calc(${px2Rem(22)}*${scale})`,
        height: `calc(${px2Rem(22)}*${scale})`,
        top: '30%',
        right: '20%'
      }
    }
  ]

  return (
    <Box
      customStyle={{
        position: 'relative',
        width: `calc(${px2Rem(63)}*${scale})`,
        height: `calc(${px2Rem(59)}*${scale})`,
        marginBottom: scale === 1 ? `${px2Rem(10)}` : ''
      }}
    >
      {
        buildItems.map((item, index) =>
          <Icon
            key={index}
            icon={item.icon}
            className={isAnimate ? item.class : ''}
            customStyle={{
              position: 'absolute',
              margin: '0',
              ...item.style
            }}
          />
        )
      }
    </Box>
  )
}

export default Build



// WEBPACK FOOTER //
// ./src/components/sections/process/Build.js